export default __webpack_public_path__ + "static/media/waiting.060e8bd3.svg";